module.exports = __webpack_public_path__ + "img/lcc2.14828d01.png";